
export const STAGE_API_URL = process.env.REACT_APP_UNIDATA_API_STAGE
export const PREPROD_API_URL = process.env.REACT_APP_UNIDATA_API_PREPROD;
export const PROD_API_URL = process.env.REACT_APP_UNIDATA_API_PROD;
export const LOCAL_API_URL = process.env.REACT_APP_UNIDATA_API_LOCAL;
export const MUI_LICENSE_KEY = process.env.REACT_APP_MUI_LICENSE_KEY;
export const PORT_MAIN_UNIDATA_API = "8002";
export const PORT_LOCAL_UNIDATA_API = "8003";